import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Card from 'components/Shared/Card';
import CardContent from '@material-ui/core/CardContent';
import Container from 'components/Shared/Container';
import GiccMeta from '../../Meta/Gicc';
import Image from 'components/Shared/Image';
import monitorJson from 'res/products/monitor.json';
import React from 'react';
import SlideShow from './SlideShow';
import {PrimaryButton as Button} from 'components/Shared/Button';
import {Divider, List} from '@material-ui/core';

function ProductCard(props) {
  const {data} = props;

  return (
    <Card className="flex flex-col justify-between py-2" color="#ffffff" bordercolor="#e5e7eb">
      <div className="flex justify-center">
        <Image src={data?.item_img} className="w-48" />
      </div>
      <CardContent>
        <div className="font-medium text-black">{data.item_name}</div>
        <div className="text-black">{data.item_spec}</div>
      </CardContent>
      <div className="flex justify-between px-4">
        <div className="text-black text-2xl">{data.item_saleprice}</div>
        <Button color="primary" href="/auth/login">
          Buy
        </Button>
      </div>
    </Card>
  );
}

// const useStyles = makeStyles(theme => ({
//   list: {
//     overflow: 'auto',
//     height: '300px',
//     // height: `calc(100vh - ${theme.spacing(6)}px)`,
//     // maxHeight: '96px',
//   },
// }));

function CategoryList() {
  // const classes = useStyles();
  return (
    <List component="nav" aria-label="secondary mailbox folders" className="text-black border border-1 bg-white ">
      <div className="p-4 text-xl font-bolder bg-gray-400">หมวดหมู่สินค้า</div>
      <Divider />
      <ul className="overflow-auto h-96 py-4">
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          Apple Products
          <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          Notebook <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          DIY <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          Monitors <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          Memory / Hardisk <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          Network Device <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          Keyboard / Mouse <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          Software <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          TV <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          Speaker <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
        <li className="flex justify-between items-center px-4 py-2 hover:text-primary">
          Office <ArrowForwardIosIcon style={{color: 'black', fontSize: '14px'}} />
        </li>
      </ul>
    </List>
  );
}

export function GiccHome() {
  return (
    <Container maxWidth="xl">
      <GiccMeta />

      <div className="md:flex pt-4 md:pt-0">
        <div className="w-full md:w-2/12 hidden md:inline">
          <CategoryList />
        </div>

        <div className="flex w-full md:w-5/12 p-0 md:p-2">
          <SlideShow />
        </div>

        <div className="flex w-full md:w-5/12">
          <div className="w-7/12 pr-2 py-2">
            <Image src="/assets/images/home/ad-04-231x294.png" />
          </div>
          <div className="flex flex-col space-y-2 w-5/12 py-2">
            <Image src="/assets/images/home/ad-05-189x167.png" />
            <Image src="/assets/images/home/ad-06-189x167.png" />
          </div>
        </div>
      </div>

      <div className="border border-2 p-4 bg-gray-200 my-4">
        <div className="text-2xl text-black">Monitors</div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-2 md:gap-4 py-4">
          {monitorJson.res.map(product => {
            return <ProductCard key={product.item_code} data={product} />;
          })}
        </div>
      </div>
    </Container>
  );
}
